<template>
	<footer class="footer">
	<div class="container">
		<div class="columns is-marginless">
			<div class="column is-paddingless is-12-touch left">
				<div class="logo-view">
					<img :src="require('@/assets/img/icon-logo-white.svg')" class="" alt="">
				</div>
				<p class="footer__text" style="margin-top: 30px">电话：020-8153 5268</p>
				<p class="footer__text">地址：广州市荔湾区黄沙大道 15 号御景壹号 南岸至尚美术馆</p>
			</div>
			<div class="column is-paddingless is-12-touch right is-flex-desktop is-flex-direction-column is-justify-content-space-between is-align-items-flex-end">
				<div class="is-hidden-touch footer__nav is-flex is-multiline">
					<router-link class="footer__nav__item" :to="{path:'/'}">首页</router-link>
					<router-link class="footer__nav__item" :to="{path:'/exhibition'}">展览</router-link>
					<router-link class="footer__nav__item" :to="{path:'/news'}">新闻公共</router-link>
					<router-link class="footer__nav__item" :to="{path:'/collection'}">典藏信息</router-link>
					<router-link class="footer__nav__item" :to="{path:'/academic'}">学术研究</router-link>
					<router-link class="footer__nav__item" :to="{path:'/about'}">关于我们</router-link>
				</div>
				<p class="footer__copyright has-text-left-touch">©️2020 SOUTH TO NOBLE ART MUSEUM  <a href="http://beian.miit.gov.cn/" style="color: white;margin-left: 10px;">粤ICP备19001049号-1</a> </p>
			</div>
		</div>
	</div>
</footer>
</template>
<script>
export default {
		name: 'header_html',
		data () {
				return {
				}
		},
		mounted: function () {
		},
		methods: {
				toTop(){
						document.documentElement.scrollTop = 0;
				},
		}
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/footer_html.vue